module.exports = __webpack_public_path__ + "static/media/main2.c7fb2a7b.jpeg";